/**
 * downloadBlobAsFile
 *
 * Dispara la descarga de un Blob en el navegador con el nombre indicado, vía
 * un anchor sintético — es el único mecanismo que permite fijar el nombre del
 * archivo desde el cliente (el `Content-Disposition` del backend queda como
 * fallback y es lo que se usa si el atributo `download` no aplica).
 *
 * El `objectURL` se revoca en el mismo tick: el click ya disparó la descarga y
 * el navegador retiene el blob hasta terminarla.
 */
export function downloadBlobAsFile(blob: Blob, fileName: string): void {
  const blobUrl = URL.createObjectURL(blob);
  const hiddenElement = document.createElement('a');
  hiddenElement.target = '_blank';
  hiddenElement.href = blobUrl;
  hiddenElement.download = fileName;
  hiddenElement.click();
  URL.revokeObjectURL(blobUrl);
}
